// extracted by mini-css-extract-plugin
export var process = "process-module--process--1Z31j";
export var processDesc = "process-module--process-desc--3UGQI";
export var processWrapper = "process-module--process-wrapper--4YRlT";